import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MultiOrgFilterComponent } from '../multi-org-filter/multi-org-filter.component';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { CommonModule } from '@angular/common';
import { AlertComponent } from 'src/app/modules/shared/components/alert/alert.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';
import { forkJoin } from 'rxjs';
import { RoleRequest, UserRole } from 'src/app/modules/user-profile/models/role-request.models';
import { PaginatorModule } from 'eas-ui-lib/paginator';

@Component({
    selector: 'app-role-request-overview',
    imports: [
        CommonModule,
        RouterModule,
        MultiOrgFilterComponent,
        AlertComponent,
        SpinnerComponent,
        PaginatorModule
    ],
    templateUrl: './role-request-overview.component.html',
    styleUrls: ['./role-request-overview.component.css']
})
export class RoleRequestOverviewComponent implements OnInit {
  private roleRequestService = inject(RoleRequestService);
  private spinner = inject(NgxSpinnerService);

  userRoles: UserRole[] = [];
  roleRequestsData = {
    roleRequests: [],
    currentData: [],
    currentPage: 1,
    pageSize: 5
  }

  roleHistoryData = {
    roleRequestsHistory: [],
    currentData: [],
    currentPage: 1,
    pageSize: 5
  }

  ngOnInit(): void {
    this.onOrgChange();
  }

  addSpacesAtCapitals(str) {
    return str.replace(/([A-Z])/g, ' $1').trim();
  }

  private loadUserRolesAndRequests(): void {
    this.spinner.show('role-request-overview');

    const userRoles$ = this.roleRequestService.getRolesByPersonKey(this.roleRequestService.getLoggedInPersonKey());
    const roleRequests$ = this.roleRequestService.getRoleRequestsByPersonKey(this.roleRequestService.getLoggedInPersonKey());

    forkJoin([userRoles$, roleRequests$]).
      subscribe(([userRolesResponse, roleRequestsResponse]: [any, RoleRequest[]]) => {
        if (userRolesResponse) {
          this.userRoles = userRolesResponse.personOrgRole.personOrgRoleList.map(x => {
            x.roleName = x.role.name;
            x.roleKey = x.role.key;
            return x;
          }).filter(x => x.organization.key === this.roleRequestService.multiOrgFilters.selectedOrganization?.orgKey);
          // sort user roles by role name
          this.userRoles.sort((a, b) => a.roleName?.localeCompare(b.roleName));
        }

        roleRequestsResponse.sort((a, b) => {
          return new Date(b.updateTs).getTime() - new Date(a.updateTs).getTime();
        });

        const pendingRequestStates = [
          "create", "submit",
          "wait", "pending"
        ];

        roleRequestsResponse.forEach(x => {
          if(x.roleRequestTypeKey == 1){
            x.roleRequestType = 'Add New Role';
          } else if(x.roleRequestTypeKey == 2){
            x.roleRequestType = 'Remove Role';
          }
        });

        if (roleRequestsResponse) {
          this.roleRequestsData.roleRequests = roleRequestsResponse.filter((x: RoleRequest) => pendingRequestStates.some(state => x.workflowStateName?.toLowerCase()?.includes(state)));
          this.OnRoleRequestPageChanged(this.roleRequestsData.currentPage);
          this.roleHistoryData.roleRequestsHistory = roleRequestsResponse.filter((x: RoleRequest) => !pendingRequestStates.some(state => x.workflowStateName?.toLowerCase()?.includes(state)));
          this.onHisoryPageChanged(this.roleHistoryData.currentPage);
        }
        this.spinner.hide('role-request-overview');
    }, () => {
      this.spinner.hide('role-request-overview');
    });
  }

  onOrgChange() {
    this.clearAllData();
    this.loadUserRolesAndRequests();
  }

  clearAllData(): void {
    this.userRoles = [];
    this.roleRequestsData.currentData = [];
    this.roleHistoryData.currentData = [];
  }

  onHisoryPageChanged(page: number) {
    this.roleHistoryData.currentData = this.roleHistoryData.roleRequestsHistory.slice((page - 1) * this.roleHistoryData.pageSize , page * this.roleHistoryData.pageSize);
    this.roleHistoryData.currentPage = page;
  }

  OnRoleRequestPageChanged(page: number) {
    this.roleRequestsData.currentData = this.roleRequestsData.roleRequests.slice((page - 1) * this.roleRequestsData.pageSize , page * this.roleRequestsData.pageSize);
    this.roleRequestsData.currentPage = page;
  }
}
